import React, { useContext, useState } from "react";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import classNames from "classnames";
import Cookies from "js-cookie";
import { Form } from "react-bootstrap";
import { RegxExpression } from "../../../utils/common";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";
import { Register } from "../../../utils/apis/login/Login";
import { loginCart } from "../../../utils/apis/addToCart/addToCart";
import Login_Green_Btn from "../../Common-Component/common_btn/login_green_btn/Login_Green_Btn";

const Sign_Up_Form = ({
  setSuccessModalShow,
  onHide,
  setFormType,
  setSuccessText,
  ...props
}) => {
  const [showLogin, setShowLogin] = useState(false);

  const handleLoginClick = () => {
    setShowLogin(true);
  };

  const [modalShow, setModalShow] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const [contactError, setContactError] = useState("");

  const navigate = useNavigate();

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const { signin, setSignin, shimmerLoader, setShimmerLoader } =
    useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    setShimmerLoader(true);
    if (password === passwordAgain) {
      const res = await Register(data);
      if (res?.success) {
        await Cookies.set("local_mandai_security", res?.data?.token);
        setSignin(true);
        await loginCart();
        // setModalShow(true);
        onHide();
        setSuccessModalShow(true);
        setSuccessText("Account Created...!");
        setTimeout(() => {
          //   setModalShow(false);
          setSuccessModalShow(false);
          setShimmerLoader(false);
          navigate(-1);
        }, 3000);
      } else {
        setShimmerLoader(false);
        if (res?.error?.contact_no) {
          setError("contact_no", { message: res?.error?.contact_no });
          setContactError(res?.error?.contact_no);
        }
        if (res?.error?.email) {
          setError("email", { message: res?.error?.email });
          setContactError(res?.error?.email);
        }

        if (res?.message?.both) {
          setError("email", { message: res?.message?.both });
          setError("contact_no", { message: "" });
        }
        if (res?.message?.email) {
          setError("email", { message: res?.message?.email });
        }
        if (res?.message?.contact_no) {
          setError("contact_no", { message: res?.message?.contact_no });
        }
      }
    } else {
      setError("re_password", { message: "Password Does not match" });
    }
  };

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  return (
    <div className="Login_Form">
      <>
        <div className="logo_content">
          <div className="logo_holder">
            <img
              src="/assets/Image/Logo/Local-MandaiFinal-Logo.png"
              className="logo_img"
            />
          </div>
          <p className="modal_haeding">GET YOUR NEEDS FULLFILLED!</p>
        </div>

        <div className="form_holder">
          <Form>
            <Form.Group className="input_group" controlId="">
              <Form.Control
                type="text"
                name="First_Name"
                placeholder="Enter First Name"
                {...register("first_name", {
                  required: "First name required",
                })}
                className={classNames("", {
                  "is-invalid": errors?.first_name,
                  "is-valid": getValues("first_name"),
                })}
                onKeyDown={(event) => {
                  if (!RegxExpression.name.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              {errors?.first_name && (
                <div className="mt-2">
                  <sup className="text-danger ">
                    {errors?.first_name?.message}
                  </sup>
                </div>
              )}
            </Form.Group>{" "}
            <Form.Group className="input_group" controlId="">
              <Form.Control
                type="text"
                name="email"
                placeholder="Enter Email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: RegxExpression.email,
                    message: "Invalid email address",
                  },
                })}
                className={classNames("", {
                  "is-invalid": errors?.email,
                  "is-valid": getValues("email"),
                })}
              />

              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                }}
              ></div>

              {errors?.email && (
                <div className="mt-2">
                  <sup className="text-danger">{errors?.email?.message}</sup>
                </div>
              )}
            </Form.Group>
            <Form.Group className="input_group" controlId="">
              <Form.Control
                className={classNames("", {
                  "is-invalid": errors?.contact_no,
                  "is-valid": getValues("contact_no"),
                })}
                type="text"
                name="contact_no"
                placeholder="Enter Mobile Number"
                {...register("contact_no", {
                  required: "Mobile Number is required",
                  minLength: {
                    value: 10,
                    message: "Number should be at least 10 characters",
                  },
                })}
                onKeyDown={(event) => {
                  if (!RegxExpression.phone.test(event.key)) {
                    if (event.key !== "Backspace") {
                      event.preventDefault();
                    }
                  }
                }}
                maxLength={10}
              />
              {errors?.contact_no && (
                <div className="mt-2">
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="">
              <div className="password_holder">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password*"
                  name="password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                    },
                  })}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    clearErrors("password"); // Clear the error when the user types
                  }}
                />

                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconOne}
                    className="icon"
                    onClick={() => togglePasswordVisibility("password")}
                  />
                </div>
              </div>

              {errors?.password && (
                <div className="mt-2">
                  <sup className="text-danger">{errors?.password?.message}</sup>
                </div>
              )}
            </Form.Group>{" "}
            <Form.Group className="mb-3" controlId="">
              <div className="password_holder">
                <Form.Control
                  type={showPasswordOne ? "text" : "password"}
                  placeholder="Re-Enter Password*"
                  name="re_password"
                  {...register("re_password", {
                    required: "Re-Password is required",
                  })}
                  onChange={(e) => {
                    setPasswordAgain(e.target.value);
                    clearErrors("re_password"); // Clear the error when the user types
                  }}
                />
                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconTwo}
                    className="icon"
                    onClick={() => togglePasswordVisibility("reenterPassword")}
                  />
                </div>
              </div>

              {errors?.re_password && (
                <div className="mt-2">
                  <sup className="text-danger">
                    {errors?.re_password?.message}
                  </sup>
                </div>
              )}
            </Form.Group>
            {password && (
              <PasswordChecklist
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={passwordAgain}
                onChange={(isValid) => {}}
                style={{
                  fontSize: "10px",
                  padding: "4px",
                  margin: "0",
                }}
              />
            )}
            <div className="submit_btn_div">
              <Login_Green_Btn
                btn_name="Sign Up"
                onClick={handleSubmit(onSubmit)}
              />
            </div>
            <p
              className="create_acc_text"
              onClick={() => {
                setFormType("login");
              }}
            >
              Log In?
            </p>
          </Form>
        </div>
      </>
    </div>
  );
};

export default Sign_Up_Form;
